import React, { useState } from 'react';

interface Member {
  id: string;
  name: string;
}

interface AddPairModalProps {
  open: boolean;
  onClose: () => void;
  members: Member[];
  onAddPair: (pair: [string, string]) => void;
}

const AddPairModal: React.FC<AddPairModalProps> = ({ open, onClose, members, onAddPair }) => {
  const [firstMember, setFirstMember] = useState('');
  const [secondMember, setSecondMember] = useState('');

  const handleAddPair = () => {
    if (firstMember && secondMember && firstMember !== secondMember) {
      onAddPair([firstMember, secondMember]);
      setFirstMember('');
      setSecondMember('');
      onClose();
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg border border-brand-200 p-6 w-full max-w-sm">
        <h2 className="text-xl font-bold mb-4">Aggiungi Coppia</h2>
        <div className="mb-3">
          <select
            className="w-full p-2 border rounded mb-2"
            value={firstMember}
            onChange={e => setFirstMember(e.target.value)}
          >
            <option value="" disabled>Seleziona primo membro</option>
            {members.map(m => (
              <option key={m.id} value={m.id}>{m.name}</option>
            ))}
          </select>
          <select
            className="w-full p-2 border rounded"
            value={secondMember}
            onChange={e => setSecondMember(e.target.value)}
          >
            <option value="" disabled>Seleziona secondo membro</option>
            {members.filter(m => m.id !== firstMember).map(m => (
              <option key={m.id} value={m.id}>{m.name}</option>
            ))}
          </select>
        </div>
        <div className="flex justify-end gap-2 mt-4">
          <button
            className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
            onClick={onClose}
          >
            Annulla
          </button>
          <button
            className="px-4 py-2 bg-brand-600 text-white rounded hover:bg-brand-700 disabled:opacity-50"
            onClick={handleAddPair}
            disabled={!firstMember || !secondMember || firstMember === secondMember}
          >
            Aggiungi Coppia
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddPairModal;
